import {
    Auditable,
    FormDataApproval,
    FormDataArchive,
    FormDataSignature,
    FormEntity,
    Lockable,
    QueryParams,
    SortParams,
    CaseFile,
} from "../..";

export interface FormData extends Auditable, Lockable {
    caseId?: number;
    formId: number;
    tissueId?: number;
    procedureId?: number;
    shipmentId?: number;
    surgeryId?: number;
    data: any;

    isFlagged: boolean;
    flagNote?: string;
    version: number;

    approvals?: FormDataApproval[];
    form?: FormEntity;
    signatures?: FormDataSignature[];
    archives?: FormDataArchive[];
    attachments?: CaseFile[];
}

export const defaultFormData: FormData = {
    formId: 0,
    data: {},
    isFlagged: false,
    version: 0,
    id: 0,
};

export const DefaultFormDataQueryParams: QueryParams = {
    caseId: "",
    formId: "",
    formCategoryId: "",
};

export const DefaultFormDataSortParams: SortParams = {
    orderBy: "formCategoryId",
    orderDesc: "false",
};
